import { render } from "./PersonalSpaceLayout.vue?vue&type=template&id=1e979452&scoped=true"
import script from "./PersonalSpaceLayout.vue?vue&type=script&lang=js"
export * from "./PersonalSpaceLayout.vue?vue&type=script&lang=js"

import "./PersonalSpaceLayout.vue?vue&type=style&index=0&id=1e979452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e979452"]])

export default __exports__